import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/pages/Layout";
import HomePage from "@/pages/HomePage";
import StatusPage from "@/pages/StatusPage";
import DocumentsPage from "@/pages/DocumentsPage";
import RequestPage from "@/pages/RequestPage";
import VerifyPage from "@/pages/VerifyPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="status" element={<StatusPage />} />
          <Route path="documents" element={<DocumentsPage />} />
          <Route path="request" element={<RequestPage />} />
          <Route path="verify" element={<VerifyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center py-16 text-center">
      <p className="text-5xl font-bold text-gray-200">404</p>
      <h1 className="mt-4 text-lg font-semibold text-gray-700">
        Page Not Found
      </h1>
      <p className="mt-2 text-sm text-gray-500">
        The page you are looking for does not exist.
      </p>
      <a
        href="/"
        className="mt-4 text-sm font-medium text-brand-primary hover:underline"
      >
        Return home
      </a>
    </div>
  );
}
